fx.service(class ThumbGenerator extends fx.Service {
    constructor(data) {
        super();

        this.model = data.creationModel;

        this._base64 = "";

        this._componentIndex = -1;

        this.canvas = document.createElement('canvas');
        this.context = this.canvas.getContext('2d');

        this.usedFontFamilies = [];
        this.fontstyle = "";

        this.generating = false;

        this.ratio = 1.5;

        // a framed poster is drawn in its frame (the cover thumbnail) ; false draws the print alone,
        // for whoever draws the frame itself (the Aperçu 3D)
        this.withFrame = true;

        // how long an image may take (null : coverImageTimeOut), and how long the drawing (null :
        // coverTimeOut, from its start). stallTimeOut instead gives up only after that long without
        // a component drawn : for whoever would rather wait for a slow photo than leave it out
        this.imageTimeOut = null;
        this.stallTimeOut = null;

        // photos at full resolution rather than the medium version the editor shows (quality "light")
        this.fullQuality = false;

        this.on("font-data-uri-loaded", this._onFontDataUriLoaded, this.model.fonts);
        this.on("load-fonts-datauri-error", this._onFontDataUriLoaded, this.model.fonts);
    }
    
    get productModel()
    {
        return this._productModel;
    }

    set productModel(val)
    {
        this._productModel = val;
    }

    get base64() {
        return this._base64;
    }

    get generating()
    {
        return this._generating;
    }

    set generating(val)
    {
        this._generating = val;

        if (this.element)
            this.element.generating = val;
    }

    get element()
    {
        return this._element;
    }

    set element(val)
    {
        this._element = val;
    }
    
    clean() {
        this._base64 = "";
    }


    /********* INIT AND MAIN FUNCTIONS *********/
    /* 
    Two main events are used for keeping the drawing procedure synchronous : font-data-uri-loaded when fonts dataURI loading is finished, 
    then draw-next-item each time a component finished drawing.
    Main steps :
    1 - generateThumbnail()
    2 - init() => load fonts DataURIs, then 'font-data-uri-loaded' event is triggered 
    3 - _onFontDataUriLoaded() => create font style for foreignElements, then 'draw-next-item' event is triggered
    4 - _drawNextItem() => start the drawing process, each component wait the next draw-next-item event before being drawn  */

    // starting point
    generate(creation, element, side, emptyPlaceHolder) {
        try {
            if (this.generating)
                return;

            //if (creation.isCalendar) side = "bottom";

            this.side = (side == "layout" ? "" : (side || (creation && creation.isBook ? "right" : "left"))); // for books we set side

            this._element = element ? element : creation.elements.getItemAt(0);
            this.components = this.element.components instanceof fx.ModelArray ? this.element.components.toArray() : this.element.components;
            this.emptyPlaceHolder = emptyPlaceHolder;

            if (creation.isPoster && fx.get("app") == "config")
                this.ratio = 2;

            this.creationSize = {
                slice: creation.sliceWidth ? creation.sliceWidth * this.ratio : 0,
                ratio: this.ratio
            };

            if (creation.isCalendar) {
                this.creationSize.width = creation.pageWidth * this.ratio;
                this.creationSize.height = creation.pageHeight * this.ratio;
                if (creation.isLayout)
                    this.creationSize.top = creation.top * this.ratio;
                else {
                    if (creation.cover_option == "desk" || creation.cover_option == "wall-single")
                        this.creationSize.top = 0;
                    else
                        this.creationSize.top = creation.pageHeight * this.ratio;
                }
                //this.creationSize.top = (creation.top !== undefined ?  creation.top : creation.pageHeight )* this.ratio;
            }
            else
                if (creation.isPrint) {
                    this.creationSize.width = (creation.shape_option ? (creation.shape_option == "landscape" ? creation.pageWidth : creation.pageHeight) : creation.pageWidth) * this.ratio;
                    this.creationSize.height = (creation.shape_option ? (creation.shape_option == "landscape" ? creation.pageHeight : creation.pageWidth) : creation.pageHeight) * this.ratio;

                    //this.creationSize.width = (creation.pageWidth ? creation.pageWidth : (creation.shape_option == "landscape" ? creation.pageWidth : creation.pageHeight)) * this.ratio;
                    //this.creationSize.height = (creation.pageHeight ? creation.pageHeight : (creation.shape_option == "landscape" ? creation.pageHeight : creation.pageWidth)) * this.ratio; 
                }
                else {
                    this.creationSize.width = creation.pageWidth * this.ratio;
                    this.creationSize.height = creation.pageHeight * this.ratio;
                }

            this.canvas.width = this.creationSize.width;
            this.canvas.height = this.creationSize.height;

            // set white background
            this.context.fillStyle = "#FFF";
            this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);

            this.generating = true;
            this._base64 = "";


            if (creation.isFrame && this.withFrame)
                this.components.push({ component_type: "frame" });

            if (creation.isCalendar && creation.isLayout) {
                this.components.push({ component_type: "calendar", content: creation.shape });
            }

            this._componentIndex = -1;
            this._release();
            this.delay(this._onDrawNextItem, null);
            this.complete = true;
            this.missing = [];

            // a photo drawn larger than the picture loaded for it : the full version would be sharper
            this.upscaled = false;

            // the photos left out because they are still on their way to the server (no picture yet)
            this.waiting = [];

            // the photos to load, the slow part of a drawing : "thumb-progress" { done, total } as each one is there
            this._photosDone = 0;
            this._photosTotal = this.components.filter((component) => component.component_type == "photo" && component.content && this._shows(component)).length;
            this.trigger("thumb-progress", { done: 0, total: this._photosTotal });
            this.usedFontFamilies = [];

            // init by loading fonts dataURI (used by ForeignObject for drawing texts)
            for (var i = 0; i < this.components.length; i++) {
                let component = this.components.getItemAt(i);

                if (component.component_type == "text") {
                    var htmlObject = document.createElement('div');
                    htmlObject.innerHTML = component.content;
                    let editor = new fx.components.TextEditor(htmlObject, null, this.model.fonts);
                    let fonts = editor.allFontFamilies;
                    for (var j = 0; j < fonts.length; j++)
                    {
                        // An unknown name (UI font, font retired since) has no dataURI to fetch, and loadDataURI would dereference the null.
                        let font = this.model.fonts.find({ name: fonts[j] });
                        if (font && this.usedFontFamilies.indexOf(font) == -1)
                            this.usedFontFamilies.push(font);
                    }

                    // the font of the text where its content names none, drawn on the editor's root
                    let defaultFont = shared.components.CoverThumbText.defaultFont(this.model.fonts, component);
                    if (defaultFont && this.usedFontFamilies.indexOf(defaultFont) == -1)
                        this.usedFontFamilies.push(defaultFont);
                }
            }

            this._waitingFonts = true;
            this.model.fonts.loadDataURI(this.usedFontFamilies); // after fonts are loaded, font-data-uri-loaded event is triggered

            // if not generated after 10 seconds, we stop it
            this.delay(this._stop, this.stallTimeOut || fx.get("settings").coverTimeOut);
        }
        catch (e) {
            this._stop();
            this.generating = false;
        }
    }

    // finished : every component drawn ; otherwise coverTimeOut ran out, and the drawing is incomplete
    _stop(finished) {
        if (this.generating) {
            if (finished !== true || (this._currentElement && this._currentElement.failed))
                this.complete = false;

            // ran out of time : the photo loading and the ones not reached are missing too
            if (finished !== true && this.components)
            {
                this._miss(this._currentElement);

                for (let i = this._componentIndex + 1; i < this.components.length; i++)
                    if (this.components.getItemAt(i).component_type == "photo" && this._shows(this.components.getItemAt(i)))
                        this._miss(new shared.components.CoverThumbPhoto(this._parameters(this.components.getItemAt(i))));
            }

            this.generating = false;
            this._componentIndex = -1;
            this._waitingFonts = false;
            this._release();
            this.delay(this._onDrawNextItem, null);

            try {
                if (this.model.creation.extraScale && this.model.creation.details == "v2") {
                    var resizedCanvas = this.resizeCanvas(this.canvas, 1 / this.model.creation.extraScale);
                    this._base64 = resizedCanvas.toDataURL();
                    resizedCanvas = null;
                }
                else
                    this._base64 = this.canvas.toDataURL();

                if (this._base64 == "data:,")
                    this._base64 = "";
            }
            catch (e) {
                // TODO : manage case of tainted canvas ("Failed to execute 'toDataURL' on 'HTMLCanvasElement': Tainted canvases may not be exported.")
                this._base64 = "";
            }
            this.trigger("thumb-generated", { side: this.side, element: this.element, thumb: this.base64, ratio: this.ratio, complete: this.complete, missing: this.missing, upscaled: this.upscaled, waiting: this.waiting });
        }
    }

    // stops the drawing running, and the loading of its picture, with no thumb-generated : for
    // whoever no longer needs it (the album preview, turned past the page)
    abort() {
        if (!this.generating)
            return;

        if (this._currentElement)
            this._currentElement.cancel();

        this.generating = false;
        this._componentIndex = -1;
        this._waitingFonts = false;
        this._release();
        this.delay(this._onDrawNextItem, null);
        this.delay(this._stop, null);
    }

    // TESTING ONLY : Add canvas to DOM for testing purposes
    previewThumbnail() {
        var img = new Image();
        img.src = this.canvas.toDataURL();
        img.onload = this.addPreviewNodeToStage.bind(this);
    }

    addPreviewNodeToStage(event) {
        var img = event.target;
        img.style.position = "absolute";
        img.style.left = "0px";
        img.style.top = "0px";
        this.stage.node.appendChild(img);
    }

    resizeCanvas(canvas, scale) {
        if (!canvas) {
            console.error("No canvas available for resizing.");
            return null;
        }

        const newCanvas = document.createElement('canvas');
        const newWidth = canvas.width * scale;
        const newHeight = canvas.height * scale;
        newCanvas.width = newWidth;
        newCanvas.height = newHeight;

        const newContext = newCanvas.getContext('2d');

        newContext.drawImage(
            canvas,
            0, 0, canvas.width, canvas.height,
            0, 0, newWidth, newHeight
        );
        return newCanvas;
    }


    /********* EVENTS *********/

    // When fonts dataURI are loaded, we trigger draw-next-item for starting the drawing procedure
    _onFontDataUriLoaded() {
        // the fonts are shared : another generator's loading answers here too, and must not start a
        // second drawing over the one running, nor one with nothing to draw
        if (!this.generating || !this._waitingFonts)
            return;

        this._waitingFonts = false;
        this.fontstyle = "";
        for (var i = 0; i < this.usedFontFamilies.length; i++) {
            if (this.usedFontFamilies[i].dataURI) {
                this.fontstyle += ` @font-face {
                        font-family: `+ this.usedFontFamilies[i].name + `;
                        font-style: normal;
                        font-weight: normal;
                        src: url(`+ this.usedFontFamilies[i].dataURI + `) format('truetype');
                    }`;
            }
        }
        this._drawNextItem();
    }

    // The drawing procedure begins here
    _drawNextItem() {
        this.delay(this._onDrawNextItem, 10);
    }


    _onDrawNextItem() {
        if (!this.generating)
            return;

        if (this._componentIndex < this.components.length - 1)
            this.drawComponent(++this._componentIndex);
        else
            this._stop(true);
    }

    _onComponentReady() {
        if (this._currentElement && this._currentElement.failed)
        {
            this.complete = false;
            this._miss(this._currentElement);

            if (this._currentElement.uploading && this._currentElement.photo)
                this.waiting.push(this._currentElement.photo);
        }

        if (this._currentElement && this._currentElement.upscaled)
            this.upscaled = true;

        if (this._currentElement && this._currentElement.counted && this._photosDone < this._photosTotal)
            this.trigger("thumb-progress", { done: ++this._photosDone, total: this._photosTotal });

        if (this.stallTimeOut)
            this.delay(this._stop, this.stallTimeOut);

        this._release();
        this._drawNextItem();
    }

    // a photo left out of the drawing, its picture not loaded (complete is false) : its zone
    // whether a photo shows on the canvas : a book's page is drawn one side at a time, and the
    // other side's photos need not load for it
    _shows(component) {
        if (component.component_type != "photo")
            return true;

        try {
            let zone = new shared.components.CoverThumbPhoto(this._parameters(component)).zone,
                w = this.canvas.width,
                h = this.canvas.height,
                angle = (zone.rotation || 0) * Math.PI / 180,
                corners = [[0, 0], [zone.width * w, 0], [0, zone.height * h], [zone.width * w, zone.height * h]].map(([x, y]) => [
                    zone.x * w + x * Math.cos(angle) - y * Math.sin(angle),
                    zone.y * h + x * Math.sin(angle) + y * Math.cos(angle),
                ]),
                xs = corners.map((c) => c[0]),
                ys = corners.map((c) => c[1]);

            return Math.max.apply(null, xs) > 0 && Math.min.apply(null, xs) < w && Math.max.apply(null, ys) > 0 && Math.min.apply(null, ys) < h;
        }
        catch (e) {
            return true;
        }
    }

    _miss(thumb) {
        try {
            if (thumb instanceof shared.components.CoverThumbPhoto && !thumb.empty)
                this.missing.push(thumb.zone);
        }
        catch (e) {
        }
    }

    // stops listening to the component drawn : one given up on (coverTimeOut) may still answer, and
    // would move the next drawing on
    _release() {
        if (this._currentElement)
            this.off("ready", this._onComponentReady, this._currentElement);

        this._currentElement = null;
    }

    /********* FUNCTIONS FOR LOADING AND DRAWING COMPONENTS ON CANVAS *********/

    _parameters(component) {
        return {
            context: this.context,
            canvas: this.canvas,
            element: this.element,
            component: component,
            model: this.productModel || this.model,
            side: this.side,
            creationSize: this.creationSize,
            fontstyle: this.fontstyle,
            emptyPlaceHolder: this.emptyPlaceHolder,
            imageTimeOut: this.imageTimeOut,
            fullQuality: this.fullQuality
        };
    }

    // draw-next-item event is triggered after each component finished drawing, for keeping the drawing synchronous
    drawComponent(index) {
        this._release();

        let component = this.components.getItemAt(index),
            parameters = this._parameters(component);

        // off the canvas : not loaded
        if (!this._shows(component))
            return this._drawNextItem();

        switch (component.component_type) {
            case "photo":
                this._currentElement = new shared.components.CoverThumbPhoto(parameters);
                break;

            case "sticker":
                this._currentElement = new shared.components.CoverThumbSticker(parameters);
                break;

            case "background":
                this._currentElement = new shared.components.CoverThumbBackground(parameters);
                break;

            case "text":
                this._currentElement = new shared.components.CoverThumbText(parameters);
                break;

            case "shape":
                this._currentElement = new shared.components.CoverThumbShape(parameters);
                break;

            case "frame":
                this._currentElement = new shared.components.CoverThumbFrame(parameters);
                break;

            case "calendar":
                this._currentElement = new shared.components.CoverThumbCalendar(parameters);
                break;

            default:
                this._currentElement = null;
                break;
        }

        if (this._currentElement) {
            // one of the photos thumb-progress counts
            this._currentElement.counted = component.component_type == "photo" && !!component.content;
            this.on("ready", this._onComponentReady, this._currentElement);
            this._currentElement.load();
        }
        else
            this._drawNextItem();
    }
});